<template>
    <div>
        <a-dropdown :trigger="['click']" :disabled="!hasPermissionToFavourite">
            <a-tooltip placement="top">
                <template #title v-if="!hasPermissionToFavourite">
                    Login first to favourite this template.
                </template>
                <a
                    class="ant-dropdown-link"
                    :class="{
                        'disabled-collection-dropdown':
                            !hasPermissionToFavourite,
                    }"
                >
                    <span class="ti-heart"></span>&nbsp; Add to favourite list
                </a>
            </a-tooltip>
            <template #overlay>
                <a-menu>
                    <a-menu-item v-for="opt in userCollections" :key="opt.id">
                        <a href="#" @click.prevent="addToCollection(opt.id)">
                            {{ opt.title | str_limit(20) }} ({{
                                opt.templates_count || 0
                            }})
                        </a>
                    </a-menu-item>
                    <template v-if="canAddCollection">
                        <a-menu-divider />
                        <a-menu-item key="new" @click="addNewCollection">
                            <i class="fa fa-plus"></i> New favourite list
                        </a-menu-item>
                    </template>
                </a-menu>
            </template>
        </a-dropdown>
        <!-- Create Collection Modal -->
        <a-modal
            :maskClosable="false"
            v-model="openModal"
            title="Create new favourite list"
            on-ok="handleSubmitModal"
        >
            <template slot="footer">
                <a-button key="back" @click.prevent="cancelModalOpen">
                    Cancel
                </a-button>
                <a-button
                    key="submit"
                    type="primary"
                    :disabled="submitting"
                    :loading="submitting"
                    @click.prevent="handleSubmitModal"
                >
                    Create favourite list
                </a-button>
            </template>
            <form>
                <div class="form-group mb-3">
                    <label for="title">Favourite List Title</label>
                    <input
                        type="text"
                        name="title"
                        v-model="collection.title"
                        class="form-control"
                        id="title"
                        :class="{
                            'is-invalid': error.title && error.title !== '',
                        }"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="error.title && error.title !== ''"
                    >
                        {{ error.title[0] }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="description">Short Description</label>
                    <textarea
                        v-model="collection.description"
                        name="description"
                        id="description"
                        cols="30"
                        rows="6"
                        class="form-control"
                    ></textarea>
                    <div
                        class="invalid-feedback"
                        v-if="error.description && error.descriptoin !== ''"
                    >
                        {{ error.descriptoin[0] }}
                    </div>
                </div>
            </form>
        </a-modal>
    </div>
</template>

<script>
import { HTTP } from "../api";

export default {
    props: [
        "role",
        "collections",
        "collectionCount",
        "templateCount",
        "template",
        "url",
    ],
    data() {
        return {
            userCollections: [],
            openModal: false,
            submitting: false,
            collection: {
                title: "",
                description: "",
            },
            error: {},
        };
    },
    computed: {
        hasPermissionToFavourite() {
            return this.role === "user";
        },
        canAddCollection() {
            return (
                this.role === "user" &&
                this.userCollections.length < this.collectionCount
            );
        },
    },
    methods: {
        canFavourite(id) {
            const collection = this.userCollections.find(
                (item) => item.id === id
            );
            if (collection) {
                return (
                    this.role === "user" &&
                    collection.templates_count < this.templateCount
                );
            }
            return false;
        },
        addNewCollection() {
            this.openModal = true;
            this.collection = {
                title: "",
                description: "",
            };
        },
        async handleSubmitModal() {
            this.submitting = true;
            this.error = {};
            try {
                const { data } = await HTTP.post(
                    "/collections",
                    this.collection
                );
                const collection = data?.collection;
                await HTTP.post("/collections/favourite-template", {
                    template_id: this.template,
                    collection_id: collection?.id,
                });
                collection.templates_count = 1;
                this.userCollections = [...userCollections, collection];
                this.collection = {
                    title: "",
                    description: "",
                };
                this.$notification.success({
                    message: "Favourite list created",
                    description:
                        "Favourite list created & template added to favourite list.",
                });
                this.openModal = false;
            } catch (error) {
                if (error?.response?.status === 422) {
                    this.error = error?.response?.data?.errors;
                } else {
                    this.$notification.error({
                        message: "Failed to create favourite list",
                    });
                }
            }
            this.submitting = false;
        },
        async addToCollection(id) {
            try {
                await HTTP.post("/collections/favourite-template", {
                    template_id: this.template,
                    collection_id: id,
                });
                const collections = this.userCollections.map((item) => {
                    if (item.id === id) {
                        item.templates_count = item.templates_count + 1;
                    }
                    return item;
                });
                this.userCollections = collections;
                this.$notification.success({
                    message: "Template added",
                    description: `Template added to the favourite list.`,
                });
            } catch (error) {
                if (error?.response?.status === 422) {
                    const data = error?.response?.data;
                    this.$notification.error({
                        message: data?.message,
                        description: data?.description,
                    });
                }
            }
        },
    },
    created() {
        if (this.role && this.role === "user") {
            this.userCollections = this.collections ? this.collections : [];
        }
    },
};
</script>

<style scoped>
.form-control {
    border: 1px solid #ced4da;
}
</style>
